import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { TFormData } from '.';

const FormCreateOrEditTransactionHeader = () => {

  const { control } = useFormContext<TFormData>();
  const _id = useWatch({ control, name: '_id' });
  const readonly = useWatch({ control, name: 'readonly' });

  const title = (
    readonly
      ? 'Détails de la transaction'
      : _id
        ? 'Modifier la transaction'
        : 'Nouvelle transaction'
  );

  const description = (
    readonly
      ? 'Informations de la transaction'
      : 'Vous êtes sur le point de créer une nouvelle transaction.'
  );

  return (
    <DialogHeader className="space-y-1 md:space-y-1 px-2 md:px-2 pt-4 md:pt-4">
      <DialogTitle className="text-lg md:text-xl">
        {title}
      </DialogTitle>
      <DialogDescription className="text-xs md:text-sm">
        {description}
      </DialogDescription>
    </DialogHeader>
  );

};

export default FormCreateOrEditTransactionHeader;
